import { useSnackbar } from "notistack"
import * as chatApi from "../api"
import { unknownErrorToString } from "../../utils/errors"
import { useTranslation } from "react-i18next"

export const useChatMutations = () => {
  const { enqueueSnackbar } = useSnackbar()
  const { t: translations } = useTranslation("translation")

  const [createChatMutation] = chatApi.useCreateChatMutation()
  const [sendMessageMutation] = chatApi.useSendMessageMutation()
  const [updateChatMutation] = chatApi.useUpdateChatMutation()
  const [deleteChatMutation] = chatApi.useDeleteChatMutation()
  const [setMessageReactionMutation] = chatApi.useSetMessageReactionMutation()
  const [updateMessageMutation] = chatApi.useUpdateMessageMutation()
  const [setMessageDeletedMutation] = chatApi.useSetMessageDeletedMutation()
  const [setMessagePinnedMutation] = chatApi.useSetMessagePinnedMutation()

  const handleError = (error: any) => {
    if (error?.data) {
      const errorCode = error.data[0]?.code
      if (errorCode === "validation_error")
        enqueueSnackbar(translations("appFallbackErrorMessage"), {
          variant: "error",
        })
      else
        enqueueSnackbar(unknownErrorToString(error), {
          variant: "error",
        })
    }
  }

  const createChat = async (data: chatApi.CreateChatData) => {
    return createChatMutation(data).unwrap().catch(handleError)
  }

  const sendMessage = async (data: chatApi.SendMessageData) => {
    return sendMessageMutation(data).unwrap().catch(handleError)
  }

  const updateChat = async (chatId: string, data: { name?: string; participantIds?: string[] }) => {
    return updateChatMutation({ chatId, ...data })
      .unwrap()
      .catch(handleError)
  }

  const updateMessage = async (data: chatApi.UpdateMessageData) => {
    return updateMessageMutation(data).unwrap().catch(handleError)
  }

  const setMessagePinned = async (data: chatApi.SetMessagePinnedData) => {
    return setMessagePinnedMutation(data).unwrap().catch(handleError)
  }

  const setMessageDeleted = async (data: chatApi.SetMessageDeletedData) => {
    return setMessageDeletedMutation(data).unwrap().catch(handleError)
  }

  const setMessageReaction = async (data: chatApi.SetMessageReactionData) => {
    return setMessageReactionMutation(data).unwrap().catch(handleError)
  }

  const deleteChat = async (chatId: string) => {
    return deleteChatMutation({ chatId }).unwrap().catch(handleError)
  }
  return {
    createChat,
    sendMessage,
    updateChat,
    deleteChat,
    setMessageReaction,
    updateMessage,
    setMessageDeleted,
    setMessagePinned,
  }
}
